import React, { useState } from "react";
import CustomModal from "./CustomModal";
import { trackEvent } from "../utils/analytics";

const REASONS = [
  { id: "other_tool", label: "I found another tool that works better for me" },
  { id: "found_job", label: "I have already found a job" },
  { id: "other", label: "Other" },
];

const ProHunterTrialEndModal = ({
  isOpen,
  paymentRail,
  cardId,
  onSubscribe,
  onSubmitFeedback,
  onClose,
}) => {
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState([]);
  const [otherText, setOtherText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const toggleReason = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleContinueFree = () => {
    trackEvent("trial_end_continue_free", "payment", {
      payment_rail: paymentRail,
    });
    setStep(2);
  };

  const handleSubscribe = async () => {
    trackEvent("trial_end_subscribe", "payment", { payment_rail: paymentRail });
    setSubmitting(true);
    try {
      await onSubscribe({ paymentRail, cardId });
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmitFeedback({
        reasons: selected,
        other_text: selected.includes("other") ? otherText : "",
      });
      trackEvent("trial_feedback_submit", "payment", {
        payment_rail: paymentRail,
        reasons: selected,
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title={step === 1 ? "Your ProHunter trial has ended" : "How was your trial?"}
      maxWidth="480px"
      closeOnOverlayClick={false}
    >
      {step === 1 ? (
        <div style={{ padding: "8px 4px 16px" }}>
          <p style={{ color: "#475569", lineHeight: 1.6 }}>
            Subscribe to keep unlimited scans, ATS insights, AI rewrites, and
            recruiter insight. Otherwise your account returns to the free plan.
          </p>
          <button
            type="button"
            onClick={handleSubscribe}
            disabled={submitting}
            style={primaryBtn}
          >
            {submitting ? "Please wait..." : "Subscribe to ProHunter"}
          </button>
          <button
            type="button"
            onClick={handleContinueFree}
            style={secondaryBtn}
          >
            Continue with Free Plan
          </button>
        </div>
      ) : (
        <div style={{ padding: "8px 4px 16px" }}>
          {REASONS.map((reason) => (
            <label
              key={reason.id}
              style={{
                display: "flex",
                gap: 8,
                marginBottom: 10,
                color: "#334155",
                fontSize: 14,
              }}
            >
              <input
                type="checkbox"
                checked={selected.includes(reason.id)}
                onChange={() => toggleReason(reason.id)}
              />
              {reason.label}
            </label>
          ))}
          {selected.includes("other") && (
            <textarea
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              placeholder="Tell us more"
              rows={3}
              style={{
                width: "100%",
                marginBottom: 12,
                padding: 8,
                borderRadius: 8,
                border: "1px solid #cbd5e1",
              }}
            />
          )}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={submitting}
            style={primaryBtn}
          >
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      )}
    </CustomModal>
  );
};

const primaryBtn = {
  width: "100%",
  background: "#3A6ED4",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  padding: "12px 16px",
  fontWeight: 700,
  cursor: "pointer",
  marginBottom: 8,
};

const secondaryBtn = {
  width: "100%",
  background: "transparent",
  color: "#334155",
  border: "1px solid #cbd5e1",
  borderRadius: 8,
  padding: "12px 16px",
  fontWeight: 600,
  cursor: "pointer",
};

export default ProHunterTrialEndModal;
